//  Images
export const striveLogo = 'strive-logo.png';
export const striveWhiteLogo = 'strive-white.svg';

// export const blueHscLogo = '10125144bd977c159a89d0fc005e6f12ddfe5e211444d11fd7b0a0da802f16376afee7a4791d2bfde541e506c40dda657c8e36c97b7a0c2f1b7e63307a2a4ee1_blue-hsc-logo.png'
// export const hscLogo = '6d823d0218585dbb63883414c840e9d84078390ccb7c34d5e586c7b3e96bb4a2f866d2e2a883b7b7e29ede656cea5f92511a09e5d598b12f2833451ac81f6095_hsc-logo.jpeg';

export const athcapBlueLogo = 'Athena+Capital+logo+design+transparent+backround+(1).png'
export const athcapLogo = 'AC+NO+CMB+LOGO_02.png';
export const videoImage = 'c311e4fc868d99a0f5309ae29b62226a0649502fcff35d1b6b120cfc62dc15de522e02467ab03e5cd71ef73defd0ac12b771356e6d50c189de99246cb8d559ca_video.png';

// Arc error codes & messages
export const existingFileError = 'E10P8A2'; // "Unable to update file, one with this path/name already exists. Please set overwrite flag or delete existing one first."
export const missingFileError = 'E10F7A1'; // "Failed to find file."
export const existingFileErrorMessage = "Unable to upload file, one with this path/name already exists"

// Text Editor
export const editorApiKey = 'z9o2fk2vqhq3k9ir26ckmi3hq9r0x1sl4s37xqokdc63n2mp';

// Enums
export const fileTypes = {
    Document: 'file',
    Photo: 'photo'
};
export const GrossType = {
    Procured: 'procured',
    Paid: 'paid'
};
export const reportTypes = {
    MarketShare: 'market-share',
    MarketTransactionBreakdown: 'market-transaction-breakdown'
};

// Others
export const startYear = 2018;
export const startYearHscFees = 2018;

export const historyWeights = [
    {
        key: 'date',
        weight: 0,
    },
    {
        key: 'status',
        weight: 1,
    },
    {
        key: 'listing_agent_1_first_name',
        weight: 2,
    },
    {
        key: 'listing_agent_firm_name',
        weight: 3,
    },
    {
        key: 'price',
        weight: 4,
    },
    {
        key: 'cap_rate',
        weight: 5,
    },
    {
        key: 'net_operating_income',
        weight: 6,
    },
    {
        key: 'price_per_sqft',
        weight: 7,
    },
    {
        key: 'base_rent',
        weight: 8,
    },
    {
        key: 'rent_per_sqft',
        weight: 9,
    },
    {
        key: 'vacancy',
        weight: 10,
    },
    {
        key: 'buyer_first_name',
        weight: 11,
    },
    {
        key: 'seller_first_name',
        weight: 12,
    },
];

export const pipelineRoutes = {
    active : 'active',
    inNegotiation : 'in-negotiation',
    underContract : 'under-contract',
    totalNegUc : 'total-neg-uc',
    inNegUcOther : 'other-neg-uc',
    closedYTD : 'closed-ytd',
    closedYTDOther : 'closed-ytd-other',
    totalClosedYTD : 'total-closed-ytd'
}

export const maxHscMembers = 2;
export const maxStriveMembers = 20;
